// mega-safe.js
(function() {
  function initMegaMenu() {
    // 找到所有 mega item
    var megaItems = document.querySelectorAll('.t4s-nav__ul li[data-mega-id]');
    if (!megaItems.length) return;

    megaItems.forEach(function(item) {
      var submenuId = item.dataset.megaId;
      if (!submenuId) return;

      var submenu = document.getElementById('mega-menu-' + submenuId);
      if (!submenu) return;

      // 鼠标悬停显示
      item.addEventListener('mouseenter', function() {
        submenu.style.display = 'block';
      });
      item.addEventListener('mouseleave', function() {
        submenu.style.display = 'none';
      });
    });
  }

  // 页面加载完成后执行
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', initMegaMenu);
  } else {
    initMegaMenu();
  }
})();
